import { render, staticRenderFns } from "./TablesWithImages.vue?vue&type=template&id=046f0fb6&"
import script from "./TablesWithImages.vue?vue&type=script&lang=js&"
export * from "./TablesWithImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports